defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Components/CouponReceipt',
  [
    'Shared/Framework/Mithril/Scripts/Core/Component',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Dictionary',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/PurchaseFlow/CouponReceipt',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/ClubPage'
  ],
  function (Component, PlayTogetherDictionary, CouponReceipt, ClubPage) {

    // Component:
    Component('coupon-receipt', [PlayTogetherDictionary], function (m, route, settings, property) {

      // Components:
      var root = {
        controller: function () {
          this.settings = settings;
          this.property = property;
          this.rootDictionary = PlayTogetherDictionary;
          this.dictionary = PlayTogetherDictionary.get.bind({ prefix: 'CouponReceipt/' });
          this.redirectLink = m.prop(settings.redirectLink || null);
          this.clubPageClassName = m.prop('receipt-step');
        },

        view: function (controller) {
          return m(ClubPage, { controller: controller }, {
            content: CouponReceipt,
            hideTopButtons: true,
          });
        }
      };

      // Routes:
      route('/', root);
    });

  });
